import axios from 'axios';
// state
const state = {
  dataMasuk: [],
};
// action
const actions = {
  async getPemasukan({ commit }, param) {
    try {
      const res = await axios.post(`${this.state.API_URL}/read_pemasukan.php`, param);
      // console.log('data',res.data.data);
      commit('setPemasukan', res.data);
    } catch (error) {
      console.error(error);
    }
  },
  async editPemasukan({ commit }, param) {
    try {
      const res = await axios.post(`${this.state.API_URL}/edit_pemasukan.php`, param);
      return res.data;
    } catch (error) {
      console.error(error);
    }

  },

  async deletePemasukan({ commit }, param) {
    try {
      const res = await axios.post(`${this.state.API_URL}/delete_pemasukan.php`, param);
      return res.data;
    } catch (error) {
      console.error(error);
    }

  },
  async addPemasukan({ commit }, param) {
    try {
      const res = await axios.post(`${this.state.API_URL}/add_pemasukan.php`, param);
      return res.data;
    } catch (error) {
      console.error(error);
    }

  },

  async filterdata({commit},param){
    try {
      const res=await axios.post(`${this.state.API_URL}/readserial.php`,param)
    } catch (error) {
      console.error (error);
    }
  },
   
  
};
const mutations = {
  setPemasukan(state, data) {
    state.dataMasuk = data.data;
     console.log('data di pemasukan',state.dataMasuk);
  },
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  state,
};
